import menuBg from 'ASSETS/img/menu/menu_bg_default.jpg';

export const hrb = {
  btnColor: {
    c0002: '#1c78c8',
    c0003: '#298dee',
    c0023: '#edf0f0',
    c0024: '#b3ddf1',
    c0025: '#5ea8ea',
    // 原color下没有，新添加c004开头
    c0041: '#1c78c8',
    c0042: '#c3c3c3',
  },
  chartColor: {
    c0001: '#3a3a3a', //x轴字体颜色
    c0002: '#9f9f9f', //y轴字体颜色
    c0003: '#3C424820', //区域横线的颜色 , //
    c0004: '#0a5f95', //['#0a5f95', '#1c78c8', '#298dee', '#5ea8ea', '#b3ddf1'], //饼图的颜色列表
    c0005: '#1c78c8', //['#1c78c8', '#298dee', '#5ea8ea', '#b3ddf1'], //柱状图的颜色列表
    c0006: '#298dee',
    c0007: '#5ea8ea',
    c0008: '#b3ddf1',
    c0009: '#0a5f95', //['#0a5f95', '#298dee', '#b3ddf1'], //折线图的颜色列表
    c0010: '#298dee',
    c0011: '#b3ddf1',
    c0012: '#5ea8ea',
    c0013: '#1967AC',
    c0014: '#1C74C1',
    c0015: '#1E80D5',
    c0016: '#298BE0',
    c0017: '#3D95E3',
    c0018: '#50A0E6',
    c0019: '#63ABE9',
    c0020: '#8F2E2C',
    c0021: 'rgba(230,107,26,1)',
    c0022: 'rgba(159,92,187, 0.99)',
    c0023: 'rgba(50,107,208, 0.99)',
    c0024: 'rgba(168, 32, 37, 1)',
    c0025: 'rgba(243, 119, 116, 1)',
    c0026: 'rgba(238, 86, 82, 1)',
    c0027: 'rgba(245,169,43,1)',
    c0028: 'rgba(56,124,185,0.99)',
  },
  chartBoxColor: {
    c0029: 'rgba(242, 242, 242, 1)',
    c0001: '#1c78c8',
    c0002: '#818181',
  },
  inpColor: {
    c0014: '#3a3a3a',
    c0015: '#737373',
    c0023: '#edf0f0',
    c0024: '#b3ddf1',
    c0026: '#edf0f0',
    transparent: 'transparent',
  },
  selecColor: {
    c0014: '#3a3a3a',
    c0015: '#737373',
    c0023: '#edf0f0',
    c0024: '#b3ddf1',
    c0026: '#edf0f0',
    c0006: '#E1FFFF',
    c0007: '#c0c3c7',
    c0008: '#d9d9d9',
    transparent: 'transparent',
  },
  tblColor: {
    c0023: '#edf0f0',
    c0025: '#5ea8ea',
    c0007: '#1c78c8',
    c0005: '#298dee',
    c0027: '#b3ddf1',
    c0028: 'rgba(183,25,1,0.2)',
    ac0027: '#DFF1FA',
    // 自定义 base color下原来没有 以c004起头
    c0040: '#eff1f5',
  },
  tabColor: {
    c0023: '#edf0f0',
    c0014: '#3a3a3a',
    c0002: '#1c78c8',
  },
  chkColor: {
    c0007: '#b71901',
  },
  layoutColor: {
    c0017: '#0a5f95',
    c0018: '#b43c43',
    c0019: 'rgb(255,255,255,0.36)',
    c0020: 'rgb(255,255,255,0.65)',
    c0021: 'rgb(55,7,1,0.4)',
    c0022: '#d9d9d9',
    c0030: '#298dee',
    c0007: '#1c78c8',
  },
  timeLineColor: {
    c0005: '#b3ddf1',
    c0017: '#296cba',
    c0003: '#298dee',
  },
  switchColor: {
    c0025: '#5ea8ea',
  },
  modalColor: {
    c0002: '#1c78c8',
  },
  datePickerColor: {
    c0001: '#3a3a3a',
    c0002: '#737373',
    c0003: '#edf0f0',
    c0004: '#b3ddf1',
    c0005: '#c0c3c7',
    c0006: '#E1FFFF',
    c0007: '#d9d9d9',
    transparent: 'transparent',
  },
  //级联菜单样式
  cascaderColor: {
    c0001: '#3a3a3a',
    c0002: '#737373',
    c0003: '#edf0f0',
    c0004: '#b3ddf1',
    c0005: '#c0c3c7',
    c0006: '#E1FFFF',
    c0007: '#d9d9d9',
    transparent: 'transparent',
  },
  // 渐变色
  gradColor: {
    g0001: ['#0a5f95', '#298dee'],
  },

  // 需要随主题色改变而改变，且无法归入共通的部分样式
  others: {
    // 渐变色
    gradColor: {
      g0001: ['#fc000b', '#9f0001'],
    },
    // 背景图片
    imgs: {
      bg0001: menuBg,
    },
    fontColor: {
      c0001: '#3a3a3a', //head的标题颜色
      c0012: '#9f9f9f',
      c0004: '#eb9f9c', //百分比大于0的颜色
      c0011: '#009dbf', //百分比小于于0的颜色
      g0001: ['#3878ac', '#96bdda'], // 概览页会员文字渐变色
      g0002: ['#333333', '#666666'], // 概览页会员文字渐变色
    },
  },
};
